import { Button, Grid, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from 'react-redux';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { Dialog, DialogContent, DialogActions, DialogTitle } from "@material-ui/core";
import Close from "@material-ui/icons/Close"
import MuiLink from "@material-ui/core/Link";
import { withStyles } from '@material-ui/styles';
import { white } from "material-ui/styles/colors";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { TextField } from "@material-ui/core";
import moment from "moment-timezone";
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import { useTranslation } from "react-i18next";

const Link = withStyles({
    root: {
        "&[disabled]": {
            color: "grey",
            cursor: "default",
            "&:hover": {
                textDecoration: "none"
            }
        }
    }
})(MuiLink);
const OutlinedTextFiled = withStyles((theme) => ({
    root: {
        "& input::placeholder": {
            fontSize: "0.75rem !important",
        },
        "& .MuiOutlinedInput-input": {
            padding: "0.62rem  !important",
        },
    },
}))(TextField);

const useStyles = makeStyles((theme) => ({
    textAlignCenter: {
        textAlign: "center"
    },
    attachButton: {
        color: theme.palette.eWhite.base,
        backgroundColor: theme.palette.ePrimary.base,
        "&:hover": {
            backgroundColor: theme.palette.ePrimary.hover,
        },
    },
    attachButtonOutlined: {
        color: theme.palette.ePrimary.base,
        backgroundColor: theme.palette.eWhite.base,
        "&:hover": {
            backgroundColor: theme.palette.eWhite.hover,
        },
    },
    dialogTitle: {
        color: theme.palette.eWhite.base,
        backgroundColor: theme.palette.ePrimary.base,
    },
    crossButton: {
        color: theme.palette.eWhite.base,
        position: 'absolute',
        right: 8,
        top: 15
    },
    yes: {
        backgroundColor: theme.palette.ePrimary.base,
        color: theme.palette.eWhite.base,
        borderRadius: 30,
        "&:hover": {
            backgroundColor: theme.palette.ePrimary.hover,
        },
        padding: "0.4rem 2rem",
        whiteSpace: "nowrap"
    },
    disableButton: {
        "& .Mui-disabled": {
            backgroundColor: theme?.palette?.eMedium?.base,
            color: theme.palette.eWhite.base,
        }
    },
    no: {
        color: theme.palette.ePrimary.base,
    },
    dialogActionPadding: {
        paddingLeft: "1.5rem",
        paddingRight: "1.5rem",
        backgroundColor: theme?.palette?.eBackground?.base
    },
    gridPadding: {
        paddingTop: "0.438rem"
    },
    justifyContEnd: {
        justifyContent: "flex-end"
    },
    paddingRightName: {
        paddingRight: "0.75rem"
    },
    paddingTopCancel: {
        [theme.breakpoints.between('sm', 'sm')]: {
            paddingTop: '1rem',
        },
    },
    textFieldBackground:{
        backgroundColor: theme.palette.eWhite.base
    },
    asterisk: {
        color: theme.palette.eDanger?.dark
    }
}))

function ETeramsConditions({ userName, termsAgreedTime, setTermsAgreedTime }) {
    const classes = useStyles();
    const {t: content} = useTranslation("content-E_UPLOAD_DOCUMENTS");
    const uploadDocumentLabels = useSelector((state) => state?.labels?.data?.getLabels?.E_DOCUMENT_UPLOAD);
    const summaryReviewLabel = useSelector((state) => state?.labels?.data?.getLabels?.E_SUMMARY_REVIEW);
    const applicantLabels = useSelector((state) => state?.labels?.data?.getLabels?.E_APPLICANT_DETAILS);

    const [openDialog, setOpenDialog] = useState(false);
    const [readTermsCondition, setreadTermsCondition] = useState("")
    const [termsandConditionText, settermsandConditionText] = useState("")
    const [timeZoneSplit, settimeZoneSplit] = useState("")

    const theme = useTheme();
    const timeZone = moment.tz.guess();
    const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

    useEffect(() => {
        settimeZoneSplit(timeZone.split("/"))
    }, [timeZone])

    useEffect(() => {
        setreadTermsCondition(content("E_PLEASE_READ_AND_AGREE_OUR_TERMS_CONDITION")?.answer);
        settermsandConditionText(content("E_UPLOAD_TERMS_AND_AGREEMENT")?.answer)
    }, [content])

    const handleCloseDialog = () => {
        setOpenDialog(false)
    }
    const handleOpenDialog = () => {
        setOpenDialog(true)
    }
    const handleSubmit = () => {
        setTermsAgreedTime(moment().toString());
        handleCloseDialog();
    }
    return (
        <Grid container direction="column"
            justifyContent="center"
            alignItems="center" spacing="2">
            <Grid item className={classes.textAlignCenter}>
                <Typography variant="subtitle2" dangerouslySetInnerHTML={{
                    __html: readTermsCondition,
                }}>
                </Typography>
            </Grid>
            <Grid item>
                <Button
                    variant={termsAgreedTime == "" ? "contained" : "outlined"}
                    onClick={handleOpenDialog}
                    className={termsAgreedTime == "" ? classes.attachButton : classes.attachButtonOutlined}
                    endIcon={termsAgreedTime == "" ? <DescriptionOutlinedIcon /> : <CheckCircleOutlineOutlinedIcon />}
                >
                    {termsAgreedTime == "" ? uploadDocumentLabels?.E_TERMS_AND_CONDITIONS : uploadDocumentLabels?.E_UPLOAD_TERMS_AGREED}
                </Button>
            </Grid>
            {termsAgreedTime != "" && <Grid item className={classes.textAlignCenter}>
                <Typography>
                <b>
                {uploadDocumentLabels?.E_UPLOAD_BY} {userName} {uploadDocumentLabels?.E_UPLOAD_AT} {moment(termsAgreedTime).format(
                    "hh:mm A"
                )} ,{moment(termsAgreedTime).format("ddd,DD MMM YYYY").toString()},{
                    timeZoneSplit[1]
                } time
            </b>
            </Typography>
            </Grid>}
            <Dialog fullScreen={fullScreen} maxWidth="md" onClose={handleCloseDialog} open={openDialog} >
                <DialogTitle className={classes.dialogTitle}>
                    <Grid container>
                        <Grid item xs="10">
                            <Typography variant="subtitle1">
                                {uploadDocumentLabels?.E_TERMS_AND_CONDITIONS}
                            </Typography>
                        </Grid>
                        <Grid item xs="2">
                            <Button startIcon={<Close />} onClick={handleCloseDialog} className={classes.crossButton}></Button>
                        </Grid>
                    </Grid>

                </DialogTitle>
                <DialogContent dividers className={classes.textCenter}>
                    <Typography>
                        {termsandConditionText}
                    </Typography>
                </DialogContent>
                <DialogActions className={classes.dialogActionPadding}>
                    <Grid container>
                        <Grid item xs={12} sm={8} md={8}>
                            <Grid container>
                                <Grid item className={[classes.gridPadding, classes.paddingRightName]}>
                                <Typography>
                                    {uploadDocumentLabels?.E_YOUR_FULL_NAME}<span className={classes.asterisk}>*</span>
                                </Typography>
                                </Grid>
                                <Grid item className={classes.paddingRightName}>
                                    <OutlinedTextFiled
                                        variant="outlined"
                                        id="nameId"
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        disabled
                                        name="name"
                                        value={userName}
                                        autoComplete="off"
                                        className={classes.textFieldBackground}
                                    />
                                </Grid>
                                <Grid item className={classes.gridPadding}>
                                    <Typography>
                                    {moment().format("dddd,DD MMM YYYY").toString()}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} className={classes.paddingTopCancel}>
                            <Grid container spacing={2} alignItems="center" className={classes.justifyContEnd}>
                                <Grid item xs="auto" className={[classes.cancelPadding, classes.gridPadding, classes.textAlignCenter]}>
                                    <Link component="button" onClick={handleCloseDialog} underline="hover" className={classes.no}>
                                        <Typography  >{summaryReviewLabel?.E_CANCEL_LABEL}</Typography>
                                    </Link>
                                </Grid>
                                <Grid item xs="auto" className={[classes.disableButton, classes.textAlignCenter]}>
                                    <Button
                                        className={[classes.yes, classes.gridPadding]}
                                        size="small"
                                        align="right"
                                        onClick={handleSubmit}
                                        disabled={termsAgreedTime != "" ? true : false}
                                    >
                                        <Typography variant="button">{uploadDocumentLabels?.E_I_AGREE}</Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default ETeramsConditions